// extracted by mini-css-extract-plugin
export default {"overlayImagesContainer":"xK-z","loadingMedia":"yK-z","reviewsImagesAndVideos":"zK-z","limitHeight":"AK-z"};